import React from 'react';
import { STEP_OPTIONS_CONFIG } from '../../config/stepTypeConfig';
import TextInputOptions from './TextInputOptions';
import FileUploadOptions from './FileUploadOptions';
import YesNoOptions from './YesNoOptions';
import MultipleChoiceOptions from './MultipleChoiceOptions';
import SignatureOptions from './SignatureOptions';
import AIImageAnalysisOptions from './AIImageAnalysisOptions';
import TableGridOptions from './TableGridOptions';
import EquipmentInspectionOptions from './EquipmentInspectionOptions';

export default function StepOptionFields({ stepType, data, onDataChange }) {
  const config = STEP_OPTIONS_CONFIG[stepType];

  const updateValidationRules = (updates) => {
    onDataChange({
      validation_rules: {
        ...data.validation_rules,
        ...updates,
      },
    });
  };

  const updateOptions = (updates) => {
    onDataChange({
      options: {
        ...data.options,
        ...updates,
      },
    });
  };

  return (
    <>
      {config.fields.includes('validation_rules') && stepType === 'TEXT_INPUT' && (
        <TextInputOptions data={data} updateValidationRules={updateValidationRules} />
      )}

      {config.fields.includes('validation_rules') && stepType === 'FILE_UPLOAD' && (
        <FileUploadOptions data={data} updateValidationRules={updateValidationRules} />
      )}

      {config.fields.includes('options') && stepType === 'YES_NO' && (
        <YesNoOptions data={data} updateOptions={updateOptions} />
      )}

      {config.fields.includes('options') && stepType === 'MULTIPLE_CHOICE' && (
        <MultipleChoiceOptions data={data} updateOptions={updateOptions} />
      )}

      {config.fields.includes('options') && stepType === 'SIGNATURE' && (
        <SignatureOptions data={data} updateOptions={updateOptions} />
      )}

      {(config.fields.includes('ai_model') || config.fields.includes('options')) && stepType === 'AI_IMAGE_ANALYSIS' && (
        <AIImageAnalysisOptions data={data} updateOptions={updateOptions} onDataChange={onDataChange} />
      )}

      {config.fields.includes('options') && stepType === 'TABLE_GRID' && (
        <TableGridOptions data={data} updateOptions={updateOptions} />
      )}

      {config.fields.includes('options') && stepType === 'EQUIPMENT_INSPECTION' && (
        <EquipmentInspectionOptions data={data} updateOptions={updateOptions} />
      )}
    </>
  );
}
